'use strict';

angular.module('ringbaPortal')
  .directive('highlight', highlight);

function highlight($timeout) {
  return {
    restrict: 'A',
    scope: {
      model: '=highlight'
    },
    link: function(scope, element) {
      scope.$watch('model', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          // apply class after change
          element.addClass('highlight');

          // auto remove after delay
          $timeout(function () {
            element.removeClass('highlight');
          }, 1000);
        }
      });
    }
  };
}
